import Header from "../components/header";
import Sidebar from "../components/sidebar";
import GroupCustomer from "../components/groupcustomer";
import Footer from "../components/footer";

function GroupCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <GroupCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default GroupCustomerPage;